import "./edit-invoice.scss";

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Outlet } from "react-router-dom";

import InvoicePreviewFile from "../../preview-file/invoice-preview-file";
// import FormInvoice from "../form-invoice/form-invoice";
import { useEditInvoice } from "./edit-invoice.hook";

export function EditInvoice() {
  const {
    downloading,
    isLoading,
    invoiceError,
    formMethod,
    actions,
    fileRef,
    handleBack,
    handleAction,
  } = useEditInvoice();

  const title = <h1>View Invoice</h1>;
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        {/* <FormInvoice /> */}
        <Outlet />
        <InvoicePreviewFile fileRef={fileRef} downloading={downloading} />
      </section>
    </div>
  );

  return (
    <div id="EditInvoice" className="invoice">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {invoiceError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditInvoice;
